'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId, MarketId } from '@morpho-org/blue-sdk';
import { getCdnUrl } from '@morpho-org/dapp-core';
import { ExternalLink } from '@morpho-org/ui-v6/server';
import { Button, Card } from '@repo/ui';
import { Arrow } from '@repo/ui/icons';
import Image from 'next/image';
import type { FixedRateAppMarketFilter } from '@/config/external-urls';
import { getFixedRateAppUrl } from '@/config/external-urls';
import { trackFixedRateAppClicked } from '@/lib/analytics/client/trackers/fixed-rate';

/**
 * Promo callout linking a variable market to the Fixed Rate app (VRM-5362).
 * Mounted only on allowlisted markets — see `getFixedRateCalloutFilter`.
 */
export default function MarketFixedRateCallout(t0) {
  const $ = _c(19);
  const {
    filter,
    chainId,
    marketId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-info relative h-[116px] w-[104px] shrink-0 rounded-l-2xl rounded-r-sm @max-[360px]:h-[92px] @max-[360px]:w-[72px]"><Image src={getCdnUrl("v2/assets/images/fixed-rate-btc.webp")} alt="" width={56} height={64} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-sm font-medium">Borrow at a fixed rate</p>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== filter.collateralSymbol || $[3] !== filter.loanSymbol) {
    t3 = <div className="min-w-0 flex-1">{t2}<p className="text-2xs text-muted-foreground">Borrow {filter.loanSymbol} against {filter.collateralSymbol} on the Morpho Fixed Rate App.</p></div>;
    $[2] = filter.collateralSymbol;
    $[3] = filter.loanSymbol;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== chainId || $[6] !== marketId) {
    t4 = () => trackFixedRateAppClicked({
      source: "market_callout",
      chainId,
      marketId
    });
    $[5] = chainId;
    $[6] = marketId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== filter) {
    t5 = getFixedRateAppUrl("market_callout", filter);
    $[8] = filter;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Arrow style={{
      transform: "rotate(-45deg)"
    }} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <ExternalLink href={t5}>Explore fixed rates{t6}</ExternalLink>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t7) {
    t8 = <Button asChild={true} size="sm" className="shrink-0" onClick={t4}>{t7}</Button>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t8) {
    t9 = <Card className="@container overflow-hidden rounded-[20px] border-[0.5px] p-0 shadow-md max-md:p-0 dark:shadow-none" data-testid="market-fixed-rate-callout"><div className="pl-2xs pr-md gap-md py-2xs @max-[360px]:pr-sm @max-[360px]:gap-sm flex w-full items-center">{t1}<div className="gap-xs flex min-w-0 flex-1 flex-col items-start @[520px]:flex-row @[520px]:items-center">{t3}{t8}</div></div></Card>;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}